import axios, { AxiosResponse } from 'axios';

export const getCachedTranslations = (language: string, name?: string) => {
    if (typeof window === 'undefined' || typeof localStorage === 'undefined') {
        return null;
    }

    return JSON.parse(localStorage.getItem(`translations-${language}-${name}`));
};

/**
 * Получение списка переводов
 */
export const getTranslations = async (language: string, name?: string): Promise<AxiosResponse> => {
    const response = await axios.get('/ru/_/service/isnareactcms/helper', {
        params: {
            name,
            action: 'translation',
            language,
        },
    });

    localStorage.setItem(`translations-${language}-${name}`, JSON.stringify(response.data));

    return response;
};

/**
 * Получение списка сервисов
 */
export const getServicesList = (context: string): Promise<AxiosResponse> => {
    return axios.get('/_/service/isnareactcms/info-services', {
        params: { context },
    });
};

export const sendEmail = (dto: FormData) => {
    return axios.post('/services/isnaportal/api/email/send', dto, {
        headers: {
            'Content-Type': `multipart/form-data; boundary=${dto._boundary}`,
        },
    });
};
